import { render, staticRenderFns } from "./mode20.vue?vue&type=template&id=3ab19cc5&scoped=true"
import script from "./mode20.vue?vue&type=script&lang=js"
export * from "./mode20.vue?vue&type=script&lang=js"
import style0 from "./mode20.vue?vue&type=style&index=0&id=3ab19cc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab19cc5",
  null
  
)

export default component.exports